import { InvestmentObjectives } from '@interfaces/models/investment-objectives-types';
import { IReceiptDTO } from '@interfaces/models/receipt.interface';
import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';
import { VgimAddress } from 'vg-interaction-model';
import { IEmploymentAssociationsState } from 'vg-interaction-model/dist/lib/features/employment/store/reducers/employment-associations/employment-associations.reducer';

import { OAAccountTypes } from './enums';

export interface IPersonalInfo {
  firstName: string;
  middleName?: string;
  suffix?: string;
  lastName: string;
  email: string;
  birthDate: string;
  citizenshipStatus: string;
  ssn_private: string;
  gender: string;
  countryOfResidence: string;
}

export interface IDecedentInfo {
  firstName?: string;
  middleName?: string;
  lastName?: string;
}

export interface IPrimaryPhone {
  phoneNumber: string;
  isMobile: boolean;
}

export interface IContactInfo {
  sameAsMailingAddress: boolean;
  mailingAddress: VgimAddress;
  streetAddress: VgimAddress;
  primaryPhone: IPrimaryPhone;
}

export interface IEmploymentInfo {
  employmentStatus: string;
  employer?: string;
  occupation?: string;
  address?: VgimAddress;
  association?: IEmploymentAssociationsState;
}

export interface IIncomeNetWorth {
  annualIncome?: string;
  liquidNetWorth?: string;
}

export interface ISources {
  F: boolean;
}

export interface IOpenAccount {
  selectedAccountTypeId: OAAccountTypes;
  config?: unknown;
  receiptDTO?: IReceiptDTO;
  decedentInfo: IDecedentInfo;
  personalInfo: IPersonalInfo[];
  contactInfo: IContactInfo[];
  fundingMethod: string;
  employmentInfo: IEmploymentInfo[];
  goals: InvestmentObjectives;
  incomeNetWorth: IIncomeNetWorth[];
  sources: ISources;
  isProspect: boolean;
  settlementFund?: SettlementFundAoAEnum;
}
